export default __webpack_public_path__ + "static/media/group-583@3x.b59f6a32.png";